import { useDispatch, useSelector } from "react-redux";
import "../../index.css";
import React from "react";
import {
  getHeight,
  getWidth,
  getCurrentHotspot,
  getHotspotPathState,
  getHotspotDisplayState,
  getActiveAlgorithm,
  getActiveHotspotDrag,
} from "../../redux/selectors";
import Hotspot from "./Hotspot";
import { dragClickListener } from "../../util/browserGeometry";
import {
  fadeHotspotPath,
  showHotspotPath,
  dragActiveHotspot,
  releaseActiveHotspotDrag,
  hotspotPathStates,
} from "../../redux/ui/ui";
import clsx from "clsx";
import { algorithms, hotspotDisplayStates } from "../../util/constants";
import { setHidden } from "../../redux";

// const [w, h] = offFrameHotspotSize;

// const useStyles = makeStyles((theme) => ({
//   locationModeHotspot: {
//     position: "absolute",
//     mixBlendMode: "difference",
//     boxSizing: "border-box",
//     width: `14px`,
//     height: `14px`,
//     borderRadius: "50%",
//     transform: "translate(-50%,-50%)",
//     transition: "transform 0.15s ease",
//     border: `1px solid white`,

//     "&:hover": {
//       transform: "translate(-50%,-50%) scale(1.14)",
//       background: "white",
//     },

//     "&::before": {
//       content: '""',
//       position: "absolute",
//       width: `${w}px`,
//       height: `${h}px`,
//       borderRadius: "50%",
//       transform: "translate(-50%, -50%)",
//       top: "50%",
//       left: "50%",
//       boxSizing: "border-box",
//       border: "1px solid white",
//     },
//   },
// }));

export const LocationModeHotspot = React.forwardRef((props, ref) => {
  const { style: extraStyle, coordinates, hotspotIndex, ...rest } = props;
  // const classes = useStyles();
  const dispatch = useDispatch();
  // const activeHotspotDrag = useSelector(getActiveHotspotDrag);
  const displayState = useSelector((state) =>
    getHotspotDisplayState(state, { hotspotIndex })
  );
  // const style = coordinates && {
  //   left: `${coordinates.x}%`,
  //   top: `${coordinates.y}%`,
  //   cursor: activeHotspotDrag ? "grabbing" : "pointer",
  // };
  const currentHotspotStyle = { opacity: 1 };

  const width = useSelector(getWidth);
  const height = useSelector(getHeight);
  let { x: x0, y: y0 } = coordinates ?? {};
  x0 = (x0 / 100) * width;
  y0 = (y0 / 100) * height;
  const onDrag = (e, { dx, dy }) => {
    // remember and enclose the initial parameters
    const el = ref.current;
    if (!el) {
      return;
    }
    const x = x0 + dx;
    const y = y0 + dy;
    dispatch(
      dragActiveHotspot({
        hotspotIndex,
        mouseCoordinatesInPercent: {
          x: (100.0 * x) / width,
          y: (100.0 * y) / height,
        },
      })
    );
  };

  const isSpinAlgorithmActive =
    useSelector(getActiveAlgorithm) === algorithms.spin;

  const onClick = (e) => {
    dispatch(setHidden());
  };

  const onDragRelease = () => dispatch(releaseActiveHotspotDrag());

  const pointerDownHandler = (e) =>
    dragClickListener(e, { onDrag, onClick, onDragRelease });

  const hotspotPathState = useSelector(getHotspotPathState);
  const isDemo = hotspotPathState === hotspotPathStates.demo;
  const activeHotspotDrag = useSelector(getActiveHotspotDrag);
  const okToShowHotspotPathOnHover =
    !activeHotspotDrag && !isDemo && isSpinAlgorithmActive;

  const commonProps = {
    onPointerEnter: () =>
      okToShowHotspotPathOnHover && dispatch(showHotspotPath()),
    onPointerLeave: () =>
      okToShowHotspotPathOnHover && dispatch(fadeHotspotPath()),
  };

  const currentHotspot = useSelector(getCurrentHotspot);

  const className = clsx(
    currentHotspot === hotspotIndex ? "currentHotspot" : "nonCurrentHotspot"
  );

  const acceptedOrApprovedHotspotComponent = (
    <Hotspot
      coordinates={coordinates}
      ref={ref}
      style={currentHotspotStyle}
      className={className}
      onPointerDown={pointerDownHandler}
      {...commonProps}
      {...rest}
    />
  );

  const displayStateToComponentMap = {
    [hotspotDisplayStates.currentNormal]: acceptedOrApprovedHotspotComponent,
    [hotspotDisplayStates.normal]: (
      <Hotspot
        ref={ref}
        coordinates={coordinates}
        className={className}
        onPointerDownCapture={(e) => e.stopPropagation()}
        {...rest}
      />
    ),
    [hotspotDisplayStates.none]: null,
    [hotspotDisplayStates.proposed]: null,
    // (
    //   <div
    //     onPointerDown={pointerDownHandler}
    //     draggable="false"
    //     className={classes.locationModeHotspot}
    //     style={{ ...style, ...extraStyle, ...currentHotspotStyle }}
    //     ref={ref}
    //     {...commonProps}
    //     {...rest}
    //   />
    // ),
    [hotspotDisplayStates.accepted]: acceptedOrApprovedHotspotComponent,
    [hotspotDisplayStates.approved]: acceptedOrApprovedHotspotComponent,
    [hotspotDisplayStates.hiddenAccepted]: null,
    [hotspotDisplayStates.hiddenApproved]: null,
  };

  return coordinates ? displayStateToComponentMap[displayState] : null;
});

export default LocationModeHotspot;
